jQuery(document).ready(function($) {
    const $blocks = $('.wp-block-jormi-blocks-mega-menu');
    const $siteHeader = $('.site-header');
    
    if ($blocks.length === 0) return;
    
    $blocks.each(function() {
        const $block = $(this);
        const blockSiblings = $block.siblings();
        const $headerElems = $siteHeader.find('.site-header-top, .wp-block-jormi-blocks-inline-logo, .overlay-trigger, .mega-menu-item').add(blockSiblings);

        const $overlay = $block.find('.mega-menu-overlay');
        
        // Handle Mobile
        const $offcanvas = $block.find('.hs-overlay');
        if ($offcanvas.length > 0) {
            const offcanvasElement = $offcanvas[0];
            
            // Overlay open
            offcanvasElement.addEventListener('open.hs.overlay', function() {     

                // Prevent scroll
                $('html, body').addClass('overflow-hidden');
                window.headerScrollDisabled = true; // prevent conflict with persistent header script

                // Handle other header elems
                $headerElems.css({
                    'position': 'relative',
                    'z-index': '100'
                });

                // Update ARIA
                const $triggerButton = $block.find('.overlay-trigger');
                $triggerButton.attr('aria-expanded', 'true');

                // Add class for CSS styling
                $siteHeader.addClass('mega-menu-open');
                $overlay.addClass('is-active');
            });
            
            // Overlay close
            offcanvasElement.addEventListener('close.hs.overlay', function() {

                // Restore scroll
                $('html, body').removeClass('overflow-hidden');
                window.headerScrollDisabled = false;

                // Reset other headerElems
                $headerElems.css({
                    'position': '',
                    'z-index': ''
                });                

                // Update ARIA
                const $triggerButton = $block.find('.overlay-trigger');
                $triggerButton.attr('aria-expanded', 'false');
                
                // Remove class for CSS styling
                $siteHeader.removeClass('mega-menu-open');
                $overlay.removeClass('is-active');
            });
        }
        
        // Handle DESKTOP
        const $dropdowns = $block.find('.hs-dropdown');
        let hoverTimeout;

        $dropdowns.each(function () {
            const dropdownElement = this;
            const $dropdown = $(this);

            dropdownElement.addEventListener('open.hs.dropdown', function () {
                clearTimeout(hoverTimeout);

                const $dropdownMenu = $dropdown.find('.hs-dropdown-menu');
                if ($dropdownMenu.length === 0) return;

                setTimeout(() => {
                    const headerHeight = $siteHeader.height();
                    const dropdownRect = $dropdownMenu[0].getBoundingClientRect();
                    const dropdownHeight = dropdownRect.height + headerHeight;

                    // Update static overlay
                    $overlay
                        .css({
                            top: `0`,
                            height: `${dropdownHeight}px`,
                        })
                        .addClass('is-active');

                    $headerElems.css({
                        position: 'relative',
                        zIndex: '99',
                    });

                    $dropdownMenu.css({ zIndex: '999' });

                    $siteHeader.addClass('mega-menu-open');
                }, 50);
            });

            dropdownElement.addEventListener('close.hs.dropdown', function () {
                hoverTimeout = setTimeout(() => {
                    const anyOpen = $block.find('.hs-dropdown-menu.hs-dropdown-open').length > 0;

                    if (!anyOpen) {
                        $overlay
                            .css({ height: '0' })
                            .removeClass('is-active');

                        $headerElems.css({
                            position: '',
                            zIndex: '',
                        });

                        $siteHeader.removeClass('mega-menu-open');
                    }
                }, 50);
            });
        });
    });
});